 <template>
  <el-row v-loading="loading">
          <el-row class="padding_5px_top">
        
        <el-row
            class="width-1150-important"
            style="margin-top: 5px;"
          >
        <el-col 
        style="width: 424px;">
          <el-col
            :span="7"
            class="fundSelector_tab"
          >
            获奖基金类型：
          </el-col>
          <el-col
            :span="15"
            class="left_text_align"
          >
            <el-select
              class="fundSelector_Company"
              v-model="categoryName"
              filterable
              placeholder="请选择基金类型"
              :filter-method="fiterCategory"
            >
              <el-option
                v-for="item in filteredCategoryList"
                :key="item.categoryName"
                :label="item.categoryName"
                :value="item.categoryName"
              >
              </el-option>
            </el-select>

          </el-col>
        </el-col>
        </el-row>


      </el-row>
      <el-divider></el-divider>
      <el-row  
        class="width-1150-important"
        v-loading="chartloading"
        >
        <el-col
            id="periodButtonGroup"
            class="right_text_align"
            style="position:absolute;"
          >
          <el-button-group>
            <el-button :type="cssGoon1" size="medium"  round @click="setPeriod('3m')">近三月</el-button>
            <el-button :type="cssGoon2" size="medium" round @click="setPeriod('6m')">近六月</el-button>
            <el-button :type="cssGoon3" size="medium" round @click="setPeriod('1y')">近一年</el-button>
            <el-button :type="cssGoon4" size="medium" round @click="setPeriod('since-inception')">成立以来</el-button>
          </el-button-group>
        </el-col>
            <el-col
              :span="24"
              id="analystRatingChart"
              class="width-1150-important height-400"
              style="margin-top:20px;"
            >
            </el-col>
            <el-col
              class="risk_date left_text_align"
              style="color:#909399;"
            >截止日期：{{anlystRatingChartDate}}
            </el-col>
      </el-row>
      <!--<el-divider></el-divider>
      <el-col 
        style="width: 424px;">
          <el-col
            :span="5"
            class="fundSelector_tab"
          >
            风险指标：
          </el-col>
          <el-col
            :span="15"
            class="left_text_align"
          >
            <el-select
              class="fundSelector_Company"
              v-model="perforamncePeriod"
              placeholder="请选择时间周期"
            >
              <el-option
                v-for="item in periodList"
                :key="item.period"
                :label="item.value"
                :value="item.period"
              >
              </el-option>
            </el-select>

          </el-col>
        </el-col>-->
        <el-row  
        style="margin-top:40px;">
        <AnalystRatingDetail ref="AnalystRatingDetail"></AnalystRatingDetail>
        </el-row>
      </el-row>
</template>
<script>
import { Message } from "element-ui";
import { getAnalystRatingCategoryList, getAnalystRatingChart, analystRatingChart } from "../../api/analystRating";
import { fiterCategory } from "./mixin/analystRatingCategory";
import { period } from "./mixin/analystRatingPeriod";
import AnalystRatingDetail from "./AnalystRatingDetail";
const componentsCommon=require("cb-components-common").default;
const checkResponseStatus=componentsCommon.common.checkResponseStatus;

export default {
  mixins: [fiterCategory, period],
    data() {
        return {
            cssGoon1:"goon",
            cssGoon2:"goon",
            cssGoon3:"goon",
            cssGoon4:"goon",
            loading: "",
            chartloading: "",
            categoryName:"积极配置 - 大盘成长",
            anlystRatingChartDate: "",
            period: "since-inception",
            perforamncePeriod: "成立以来",
            params: {
                categoryName: "",
                period: ""
            }
        };
    },
    components: {AnalystRatingDetail},
     mounted() {
      const self = this;
      self.cssGoon1="goon";
      self.cssGoon2="goon";
      self.cssGoon3="goon";
      self.cssGoon4="goon-focus";
      self.loadingData(self.params);
     },
     watch: {
       categoryName: function(val) {
          const self = this;
          self.getAnalystRatingChart();
          self.$refs.AnalystRatingDetail.loadingDataByCategory(val);
        },

    },
methods: {
        loadingData() {
            const self = this;
            self.getAnalystRatingChart();
            self.handleCategory();
            // self.getAnalystRatingPeriod(self.params);
        },
        setPeriod:function(period) {
          const self = this;
          if(period == "3m") {
            self.cssGoon1="goon-focus";
            self.cssGoon2="goon";
            self.cssGoon3="goon";
            self.cssGoon4="goon";
          }
          else if(period == "6m") {
            self.cssGoon1="goon"
            self.cssGoon2="goon-focus";
            self.cssGoon3="goon";
            self.cssGoon4="goon";
          }
          else if(period == "1y") {
            self.cssGoon1="goon";
            self.cssGoon2="goon";
            self.cssGoon3="goon-focus";
            self.cssGoon4="goon";
          }
          else if(period == "since-inception") {
            self.cssGoon1="goon";
            self.cssGoon2="goon";
            self.cssGoon3="goon";
            self.cssGoon4="goon-focus";
          }
          self.period = period;
          self.getAnalystRatingChart();
        },
        getAnalystRatingChart() {
            let self = this;
            if(self.categoryName != "" && self.period != "") {
              self.chartloading = true;
              self.params.categoryName=self.categoryName;
              self.params.period = self.period;
              getAnalystRatingChart(self.params)
                  .then(response => {
                      let jsonData = response.data;
                      if (jsonData == undefined) {
                          Message({
                              message: "数据异常，请尝试刷新再试！",
                              type: "error",
                              duration: 2 * 1000
                          });
                          Message.close = function() {};
                      } else {
                          if (checkResponseStatus(jsonData, self)) {
                              let result = jsonData.data;
                              self.anlystRatingChartDate = result.analystRatingChart.anlystRatingChartDate;
                              analystRatingChart(
                                  "#analystRatingChart",
                                  result.analystRatingChart, self
                              );
                          }
                      }
                  })
                  .catch(err => {
                      self.chartloading = false;
                      Message({
                          message: "数据异常，请尝试刷新再试！",
                          type: "error",
                          duration: 2 * 1000
                      });
                      Message.close = function() {};
                      console.log(err);
                  })
                  .finally(r => {
                      self.chartloading = false;
                  });
            } 
            
        }

}
    }
</script>
<style lang="scss">
.fundSelector_tab {
    height: 40px;
    line-height: 40px;
    color: rgba(0, 0, 0, 1);
    font-size: 16px;
    text-align: left;
}
.fundSelector_Company {
    width: -webkit-fill-available !important;
}
@import "../../public/sass/components/analystRating";
</style>